import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { PageResponse } from '@core/entities/pagination'
import { IRegister, Register } from '@core/entities/register/Register'
import { registersQueryKeys } from '@core/react-query/features/registers/registers'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { usePageableQuery } from '@core/react-query/hooks'

const dataTransformer = (response: PageResponse<IRegister>) => {
  return {
    ...response,
    content: response.content.map((user) => Register.new(user)),
  }
}

export const useGetRegisters = (
  payload: RequestTypes['getRegisters'],
  options?: UseInfiniteQueryOptions<
    PageResponse<IRegister>,
    RequestErrorType,
    PageResponse<Register>
  >,
) => {
  const registersQuery = registersQueryKeys.registers(payload)

  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options?.enabled,
    queryKey: registersQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<IRegister>,
    RequestErrorType,
    PageResponse<Register>
  >({
    ...registersQuery,
    ...infiniteQueryOptions,
    cacheTime: 0,
    keepPreviousData: true,
    ...options,
  })
}
